import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import Home from "../app/(general-header)/home/page";

const root = createRoot(document.getElementById("botb-homepage") as HTMLElement);

root.render(
  <StoreProvider>
    <Home />
  </StoreProvider>
);
